export default __webpack_public_path__ + "media/images/images/banner/parallax-4-eb212225faaddfc2b3e5775f9eccd71b.jpg";